/**
 * Servidores MySQL con réplica que deben mostrarse en dashboard y /mysql.
 * Orden: master Servi, slave Servi, réplicas ESM ya monitoreadas.
 */
export const MYSQL_REPLICA_PRIORITY_IDS = [1, 2, 5, 22];

/** Slaves MySQL mostrados en la fila 1 del dashboard (3 réplicas). */
export const MYSQL_SLAVE_IDS = [2, 5, 22]; // Servi, A1 ESM 208.87.134.70, Contabo

export function sortMysqlReplicaServers(servers) {
  const list = (servers || []).filter((s) => s.id !== 0);
  const byId = new Map(list.map((s) => [s.id, s]));
  const ordered = [];

  MYSQL_REPLICA_PRIORITY_IDS.forEach((id) => {
    if (byId.has(id)) {
      ordered.push(byId.get(id));
      byId.delete(id);
    }
  });

  [...byId.values()]
    .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || ''))
    .forEach((s) => ordered.push(s));

  return ordered;
}
